/* Cursor-follow glow + subtle 3D tilt for product cards.
   Single delegated mousemove listener on document, targeting [data-card-tilt].
   Respects prefers-reduced-motion: disables transforms/glow tracking. */
(function () {
  'use strict';

  if (window.__hhsCardInteractions) return;
  window.__hhsCardInteractions = true;

  var reduceMotion =
    window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (reduceMotion) return;

  var MAX_TILT = 5; // degrees

  document.addEventListener(
    'mousemove',
    function (e) {
      var card = e.target.closest && e.target.closest('[data-card-tilt]');
      if (!card) return;

      var rect = card.getBoundingClientRect();
      if (!rect.width || !rect.height) return;

      var px = (e.clientX - rect.left) / rect.width; // 0..1
      var py = (e.clientY - rect.top) / rect.height; // 0..1

      // Glow position as percentages.
      card.style.setProperty('--mx', (px * 100).toFixed(2) + '%');
      card.style.setProperty('--my', (py * 100).toFixed(2) + '%');

      // Tilt: center is 0. rotateY follows X, rotateX inverse-follows Y.
      var ry = (px - 0.5) * 2 * MAX_TILT; // -MAX..MAX
      var rx = (0.5 - py) * 2 * MAX_TILT;
      card.style.setProperty('--rx', rx.toFixed(2) + 'deg');
      card.style.setProperty('--ry', ry.toFixed(2) + 'deg');
    },
    { passive: true }
  );

  // Reset tilt vars on leave so the CSS transition eases back to the resting base.
  document.addEventListener(
    'mouseout',
    function (e) {
      var card = e.target.closest && e.target.closest('[data-card-tilt]');
      if (!card) return;
      // Only reset when the pointer actually leaves the card.
      var to = e.relatedTarget;
      if (to && card.contains(to)) return;
      card.style.setProperty('--rx', '0deg');
      card.style.setProperty('--ry', '0deg');
    },
    { passive: true }
  );
})();
